import { TextBadge } from '#/components/Badge/TextBadge';
import { useI18n } from '#/i18n/hooks/useI18n';
import { SEARCH_COMMON_REFINEMENT_LABELS } from '#/modules/search/constants/refinements/searchCommonRefinementTypes';
import { useSearchFacetSelectedValues } from '#/modules/search/hooks/facets/useSearchFacetSelectedValues';
import type { SearchRefinementVariant } from '#/modules/search/types/SearchRefinementVariant';
import { LOCALE_CHECKBOX_OPTIONS } from '#/utils/constants/general/locales';

import { SearchFacetAccordionItem } from './AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from './Dropdown/SearchFacetDropdown';
import { SearchFacetCheckboxOptions } from './Options/SearchFacetCheckboxOptions';

type Props = {
  variant: SearchRefinementVariant;
};
export function LocaleFacet({ variant }: Props) {
  const { i18n } = useI18n();

  const selectedFacetValues = useSearchFacetSelectedValues('locale');

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  return (
    <FacetVariant
      facetType="locale"
      icon="speech-bubble"
      label={
        <>
          {SEARCH_COMMON_REFINEMENT_LABELS(i18n).locale}{' '}
          <TextBadge content={selectedFacetValues.length} />
        </>
      }
    >
      <SearchFacetCheckboxOptions
        facetType="locale"
        initialValue={selectedFacetValues}
        options={LOCALE_CHECKBOX_OPTIONS()}
      />
    </FacetVariant>
  );
}
